(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["img-carousel"] && !Shopify.designMode) return;
  try {
    
// Optional: Add JavaScript for carousel functionality if needed

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_recommendation"] && !Shopify.designMode) return;
  try {
    
   var loadProductRecommendationsIntoSection = function() {
     var productRecommendationsSection = document.querySelector(".product-recommendations");
     if (productRecommendationsSection === null) { return; }
     var productId = productRecommendationsSection.dataset.productId;
     var baseUrl = productRecommendationsSection.dataset.baseUrl;
     var limit = productRecommendationsSection.dataset.limit;
     var sectionId = productRecommendationsSection.dataset.sectionId;
     var requestUrl = baseUrl + "?section_id="+ sectionId +"&product_id=" + productId + "&limit=" + limit;
     var request = new XMLHttpRequest();
     request.open("GET", requestUrl);
     request.onload = function() {
       if (request.status >= 200 && request.status < 300) {
         var container = document.createElement("div");
         container.innerHTML = request.response;
         productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;

         var flkty = $('.productRec__slides').flickity({
            wrapAround: true,
            contain: true,
            prevNextButtons: false,
            pageDots: false
        }) 
        $('.productRec__buttons .btn--prev').on( 'click', function() {
          flkty.flickity('previous');
        });

         $('.productRec__buttons .btn--next').on( 'click', function() {
          flkty.flickity('next');
        });

       }
     };
     request.send();
   };

   document.addEventListener("shopify:section:load", function(event) {
     if (event.detail.sectionId === "product-recommendations") {
       loadProductRecommendationsIntoSection();
     }
   });
   loadProductRecommendationsIntoSection();
   
  } catch(e) { console.error(e); }
})();
})();
